import {css} from 'lit';
export const styles = css`.filter-bar .bu-btn {
    --btn-font-weight: 400;
    --btn-height: 32px;
  }
  .filter-bar ef-badge {
    --secondary: #d70015;
  }
  .filter-bar .btn-primary {
    --btn-color: var(--dark-text);
    --btn-bg: var(--blue-new-100);
    --btn-border-color: var(--blue-new-100);
    --btn-hover-color: var(--dark-text);
    --btn-hover-bg: var(--blue-new-200);
    --btn-hover-border-color: var(--blue-new-200);
    --btn-active-color: var(--dark-text);
    --btn-active-bg: var(--blue-new-300);
    --btn-active-border-color: var(--blue-new-300);
  }
  .filter-bar .btn-outline-dark {
    --btn-border-color: var(--gray-new-300);
    --btn-hover-bg: var(--gray-new-100);
    --btn-hover-border-color: var(--gray-new-300);
    --btn-active-bg: var(--gray-new-200);
    --btn-active-border-color: var(--gray-new-300);
  }

:host {
  display: block;
}

header {
  margin-bottom: 16px;
}

.filter-bar {
  margin-bottom: 8px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--border);
}
`;
export default styles;
